import { useEffect, useMemo, useState } from "react";
import { useMapsLibrary } from "@vis.gl/react-google-maps";
import { GMAPS_KEY } from "./gmaps";

/**
 * Calcola distanze e tempi di guida reali tra le tappe (Google Directions).
 * Restituisce null finché non disponibile: chiave assente, meno di 2 tappe o
 * Directions API non abilitata sulla chiave. In quel caso l'UI resta pulita.
 * route = { legs: [{distanceText, durationText, distanceM, durationS}], path,
 *           totalDistanceM, totalDurationS }
 */
export const useRouteLegs = (stops) => {
    const routesLib = useMapsLibrary("routes");
    const [route, setRoute] = useState(null);
    const signature = useMemo(() => stops.map((s) => `${s.lat},${s.lng}`).join("|"), [stops]);

    useEffect(() => {
        if (!GMAPS_KEY || !routesLib || stops.length < 2) {
            setRoute(null);
            return undefined;
        }
        let cancelled = false;
        const svc = new routesLib.DirectionsService();
        const [first, ...rest] = stops;
        const last = rest.pop();
        svc.route({
            origin: { lat: first.lat, lng: first.lng },
            destination: { lat: last.lat, lng: last.lng },
            waypoints: rest.map((s) => ({ location: { lat: s.lat, lng: s.lng }, stopover: true })),
            travelMode: "DRIVING",
        }).then((res) => {
            if (cancelled || !res.routes?.length) return;
            const r = res.routes[0];
            setRoute({
                legs: r.legs.map((l) => ({
                    distanceText: l.distance.text,
                    durationText: l.duration.text,
                    distanceM: l.distance.value,
                    durationS: l.duration.value,
                })),
                path: r.overview_path.map((p) => ({ lat: p.lat(), lng: p.lng() })),
                totalDistanceM: r.legs.reduce((a, l) => a + l.distance.value, 0),
                totalDurationS: r.legs.reduce((a, l) => a + l.duration.value, 0),
            });
        }).catch(() => {
            if (!cancelled) setRoute(null);
        });
        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [routesLib, signature]);

    return route;
};

export const fmtKm = (m) => (m >= 1000 ? `${(m / 1000).toFixed(m >= 10000 ? 0 : 1)} km` : `${m} m`);

export const fmtDrive = (s) => {
    const min = Math.round(s / 60);
    return min >= 60 ? `${Math.floor(min / 60)}h${min % 60 ? ` ${min % 60}m` : ""}` : `${min}m`;
};
